import { render } from "./StockEmptyState.vue?vue&type=template&id=5b099609&scoped=true"
import script from "./StockEmptyState.vue?vue&type=script&lang=js"
export * from "./StockEmptyState.vue?vue&type=script&lang=js"

import "./StockEmptyState.vue?vue&type=style&index=0&id=5b099609&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b099609"]])

export default __exports__